import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function EditSectionQuestion() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-868" data-mp="zsalvgjc0q3a">
      <div className="flex items-center justify-between" data-id="element-869" data-mp="zrj356au2muf">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-870" data-mp="329z1n2iwjom">
          {isEdit ? 'Edit Section Question' : 'Add Section Question'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions')} data-id="element-871" data-mp="73vijr9kbw7s">
          ← Back to Questions
        </Button>
      </div>

      <Card data-id="element-872" data-mp="1nh3k5jnffa12">
        <CardContent className="pt-6" data-id="element-873" data-mp="1nhd9r64k7f68">
          <form className="space-y-5 max-w-2xl" data-id="element-874" data-mp="1sg6sbcypdwd9">
            <div data-id="element-875" data-mp="1sevcufvwb06b">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-876" data-mp="1sij7xjgznun5">
                Course
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[200px]" defaultValue={isEdit ? '1' : ''} data-id="element-877" data-mp="1r1g5eujfo0si">
                <option value="" data-id="element-878" data-mp="1h27fqdvlp8by">-- Select Course --</option>
                <option value="1" data-id="element-879" data-mp="1c4flvebebc54">Desert Ecology Basics</option>
                <option value="2" data-id="element-880" data-mp="1c60hz8dcz353">Advanced Water Conservation</option>
                <option value="3" data-id="element-881" data-mp="17ce3rbrjqr76">Sustainable Landscaping</option>
              </select>
            </div>

            <div data-id="element-882" data-mp="13c3vfsga7op5">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-883" data-mp="139hrs3wihtc7">
                Section
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[160px]" defaultValue={isEdit ? '1' : ''} data-id="element-884" data-mp="td4yh74vphhz">
                <option value="" data-id="element-885" data-mp="epxvpopjrpu6">-- Select Section --</option>
                <option value="1" data-id="element-886" data-mp="jpix05s6waa2">Section 1</option>
                <option value="2" data-id="element-887" data-mp="jrddn7wfhg8c">Section 2</option>
                <option value="3" data-id="element-888" data-mp="5qj58p9drf9o">Section 3</option>
              </select>
            </div>

            <div data-id="element-889" data-mp="9rcsrhiwus21">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-890" data-mp="9quqo49khjm7">
                Question
              </label>
              <textarea className="w-full min-h-[100px] rounded border border-slate-300 bg-white p-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 resize-y" defaultValue={isEdit ? 'What is the primary water source for desert flora?' : ''} data-id="element-891" data-mp="xhqpvmgcrh3h" />
            </div>

            <div data-id="element-892" data-mp="1gei43hh1f60o">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-893" data-mp="1gdykzxfnibl2">
                Answer
              </label>
              <div className="flex items-center gap-6" data-id="element-894" data-mp="35x6vot81q80x">
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-895" data-mp="35vm3395akz5p">
                  <input type="radio" name="answer" value="yes" defaultChecked={isEdit} className="focus:ring-slate-400" data-id="element-896" data-mp="30x2ef0zbd99n" />
                  <span className="text-sm text-slate-700" data-id="element-897" data-mp="3aq00ti7ffidj">Yes</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-898" data-mp="2mykttc4pgcvy">
                  <input type="radio" name="answer" value="no" className="focus:ring-slate-400" data-id="element-899" data-mp="2i0jb4sb6yfl0" />
                  <span className="text-sm text-slate-700" data-id="element-900" data-mp="2rwmcvx24sc7f">No</span>
                </label>
              </div>
            </div>

            <div className="pt-2" data-id="element-901" data-mp="c4gfstxc3lbf">
              <Button type="submit" data-id="element-902" data-mp="77gfz0r2vesr">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}